export const TRIAL_COMPONENTS_EXPERIENCES = {
	ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
	// The trial grace period is formally known as the "pre-dunning" period
	GRACE_PERIOD_BANNER_DISMISSED: 'trial-components:trialGracePeriodBannerDismissed',
};
